<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <RadioMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [
        { name: "订单管理" },
        { name: "合同订单" },
      ],
      menu: [
        {
          name: "自有车辆",
          path: '/order/contract/own',
        },
        {
          name: "雇佣车辆",
          path: '/order/contract/hire',
        },
      ],
      menuIndex: '/order/contract/own',
    };
  },
  watch: {
    $route() {
      this.matchPath()
    },
  },
  methods: {
    matchPath() {
      this.menu.map(v => {
        if (this.$route.path.includes(v.path)) {
          this.menuIndex = v.path
        }
      })
    },
  },
  mounted() {
    this.matchPath()
  },
};
</script>
